import animation, { fadeIn } from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import LinkButtonStyles from '@stories/Components/Buttons/LinkButton/LinkButton.styles';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const linkStyles = css `
  background-color: transparent;
  background-image: linear-gradient(to right, ${brand.green} 0%, ${brand.green} 100%);
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: ${cssVar('fgColor')};
  ${fonts.gotham.regular};
  margin: -3px;
  padding: 3px;
  text-decoration: underline;
  text-underline-position: under;
  transition: background-size 0.15s ease-out;

  [data-theme='whiteBurgundy'] & {
    background-image: linear-gradient(to right, ${brand.burgundy} 0%, ${brand.burgundy} 100%);
  }

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    background-size: 100% 100%;
  }
`;
const tableStyles = css `
  margin: 0 0 16px;

  th,
  td {
    border: 1px solid ${cssVar('fgColor')};
    color: ${cssVar('fgColor')};
    ${ParagraphStyles.RegularStyles};
    height: auto !important; // override inline height - no point this being content editable.
    margin: 0;
    padding: 8px 16px;
  }
`;
const contentStyles = css `
  color: ${cssVar('fgColor')};
  ${fonts.gotham.regular};

  h1 {
    ${HeadingStyles.H1Styles};
  }

  h2 {
    ${HeadingStyles.H2Styles};
  }

  h3 {
    ${HeadingStyles.H3Styles};
  }

  h4 {
    ${HeadingStyles.H4Styles};
  }

  h5 {
    ${HeadingStyles.H5Styles};
  }

  h6 {
    ${HeadingStyles.H6Styles};
  }

  p {
    ${ParagraphStyles.RegularStyles};
  }

  strong {
    ${fonts.gotham.bold};
  }

  ol,
  ul {
    display: block;
    ${ParagraphStyles.RegularStyles};
    padding: 0 0 0 40px;
  }

  ol {
    list-style: decimal;

    li {
      display: list-item;
    }
  }

  ul {
    list-style: disc;

    li {
      display: list-item;
    }
  }

  a {
    ${linkStyles};
  }

  > *:last-child {
    margin-bottom: 0;
  }

  table {
    ${tableStyles};
  }

  hr {
    margin: 16px 0;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  sub {
    position: relative;
    top: 0.5em;
    font-size: 80%;
  }
`;
const Container = styled(SectionWrapper) `
  ${LinkButtonStyles.Button} {
    margin-top: 48px;
  }

  @media ${from(Device.TabletLarge)} {
    opacity: 0;

    ${({ isActive }) => isActive &&
    css `
        ${fadeIn(isActive, 375, 0, animation.easeInOutCubic)};
      `}
  }
`;
const Content = styled.div `
  margin: 0 auto;
  width: 100%;

  ${contentStyles}

  ${({ leadParagraph }) => leadParagraph &&
    css `
      p:first-child {
        ${ParagraphStyles.LargeStyles};
      }
    `}
`;
export default {
    Container,
    Content,
    contentStyles,
    linkStyles,
};
